const c = {
  name: "Abacus",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,40V0h2v7h2.1c0.4-1.7,2-3,3.9-3c1.2,0,2.3,0.5,3,1.4C11.7,4.5,12.8,4,14,4s2.3,0.5,3,1.4
			C17.7,4.5,18.8,4,20,4c1.9,0,3.4,1.3,3.9,3H38V0h2v40h-2v-7h-2.1c-0.4,1.7-2,3-3.9,3c-1.2,0-2.3-0.5-3-1.4c-0.7,0.8-1.8,1.4-3,1.4
			c-1.9,0-3.4-1.3-3.9-3H11.9c-0.4,1.7-2,3-3.9,3c-1.9,0-3.4-1.3-3.9-3H2v7H0z M23.9,9c-0.4,1.7-2,3-3.9,3c-1.2,0-2.3-0.5-3-1.4
			c-0.7,0.8-1.8,1.4-3,1.4s-2.3-0.5-3-1.4C10.3,11.5,9.2,12,8,12c-1.9,0-3.4-1.3-3.9-3H2v10h2.1c0.4-1.7,2-3,3.9-3
			c1.2,0,2.3,0.5,3,1.4c0.7-0.8,1.8-1.4,3-1.4c1.9,0,3.4,1.3,3.9,3h10.3c0.4-1.7,2-3,3.9-3c1.9,0,3.4,1.3,3.9,3H38V9H23.9z M16,8
			c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2s0.9,2,2,2C15.1,10,16,9.1,16,8z M18,8c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2s-0.9-2-2-2
			C18.9,6,18,6.9,18,8z M8,6C6.9,6,6,6.9,6,8s0.9,2,2,2c1.1,0,2-0.9,2-2S9.1,6,8,6z M4.1,31c0.4-1.7,2-3,3.9-3c1.9,0,3.4,1.3,3.9,3
			h10.3c0.4-1.7,2-3,3.9-3c1.2,0,2.3,0.5,3,1.4c0.7-0.8,1.8-1.4,3-1.4c1.9,0,3.4,1.3,3.9,3H38V21h-2.1c-0.4,1.7-2,3-3.9,3
			c-1.9,0-3.4-1.3-3.9-3H17.9c-0.4,1.7-2,3-3.9,3c-1.2,0-2.3-0.5-3-1.4C10.3,23.5,9.2,24,8,24c-1.9,0-3.4-1.3-3.9-3H2v10H4.1z
			 M32,34c1.1,0,2-0.9,2-2s-0.9-2-2-2c-1.1,0-2,0.9-2,2S30.9,34,32,34z M26,30c-1.1,0-2,0.9-2,2s0.9,2,2,2c1.1,0,2-0.9,2-2
			S27.1,30,26,30z M10,20c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2C9.1,22,10,21.1,10,20z M12,20c0,1.1,0.9,2,2,2
			c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2C12.9,18,12,18.9,12,20z M32,18c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2
			C34,18.9,33.1,18,32,18z M6,32c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2s-0.9-2-2-2C6.9,30,6,30.9,6,32z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Abacus
};
